import { getProvider } from "../providerInstance";
import { getState, updateState } from "../state";

export async function refreshNotifications(): Promise<void> {
  try {
    const notifications = await getProvider().listNotifications();
    const unreadCount = notifications.filter((n: any) => !n.read).length;
    updateState({ notifications, unreadCount } as any);
  } catch {
    // Best-effort
  }
}

export async function markAllRead(): Promise<void> {
  const state = getState();
  for (const n of state.notifications) {
    if (!n.read) {
      try { await getProvider().markNotificationRead(n.id); } catch { /* best effort */ }
    }
  }
  const updated = state.notifications.map((n) => ({ ...n, read: true }));
  updateState({ notifications: updated, unreadCount: 0 } as any);
}
